<div class="not-found">
  <h1 class="not-found__title">404 not found</h1>
</div>
